import requests from "./httpService";

const SchoolFoodMenuService = {
  addMenu(body) {
    return requests.post("/school-food-menu/add", body);
  },

  updateMenu(id, body) {
    return requests.put(`/school-food-menu/${id}`, body);
  },

  deleteMenu(id) {
    return requests.delete(`/school-food-menu/${id}`);
  },

  listBySchool(schooleId, includeInactive = false, bypassCache = false) {
    const cacheParam = bypassCache ? `&_=${Date.now()}` : "";
    return requests.get(
      `/school-food-menu/school/${schooleId}?includeInactive=${includeInactive ? "true" : "false"}${cacheParam}`
    );
  },

  // Parent module can call this without schooleId because auth already carries it.
  getParentActive({ moduleType = "MASTER", classId, date } = {}) {
    const params = new URLSearchParams();
    if (moduleType) params.set("moduleType", moduleType);
    if (classId) params.set("classId", classId);
    if (date) params.set("date", date);
    const query = params.toString();
    return requests.get(`/school-food-menu/parent/active${query ? `?${query}` : ""}`);
  },
};

export default SchoolFoodMenuService;
